import React, { useState } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './Program.css';

// Resim importları
import calistay1 from '../../assets/calistay1.jpeg';
import calistay2 from '../../assets/calistay2.jpeg';
import calistay3 from '../../assets/calistay3.jpeg';
import calistay4 from '../../assets/calistay4.jpeg';

function Program() {
  // Pop-up kontrolü için state'ler
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const images = [calistay1, calistay2, calistay3, calistay4];

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div className="program-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>KONGRE PROGRAMI</h2>
          <p>20 - 23 Mayıs 2026 | Sivas</p>
        </div>
      </header>

      <main className="content-container">
        {/* Önemli Genel Uyarı */}
        <div className="notice-card">
          <i className="fas fa-exclamation-circle"></i>
          <p>KONGRE PROGRAMI BİLDİRİ DEĞERLENDİRME SÜRECİ SONRASINDA İLAN EDİLECEKTİR.</p>
        </div>

        <div className="program-grid">
          {/* Oturum Bilgisi */}
          <div className="program-card highlight">
            <div className="card-header">
              <span className="date">21 - 22 Mayıs 2026</span>
              <h3>Kongre Oturumları</h3>
            </div>
            <div className="card-body">
              <p>Kongremiz, <strong>yüz yüze oturumlarla</strong> gerçekleştirilecektir. Uzaktan (çevrimiçi) katılım seçeneği bulunmamaktadır.</p>
            </div>
          </div>

          {/* Çalıştay - Tıklanabilir Kart */}
          <div className="program-card clickable" onClick={() => openLightbox(0)}>
            <div className="card-header">
              <span className="date">20 Mayıs 2026 Çarşamba</span>
              <h3>Metodoloji Çalıştayı</h3>
              <small className="click-hint">(Büyütmek için görsellere tıkla)</small>
            </div>
            <div className="card-body">
              <div className="workshop-photos">
                {images.map((img, idx) => (
                  <img 
                    key={idx} 
                    src={img} 
                    alt={`Metodoloji Çalıştayı ${idx + 1}`} 
                    onClick={(e) => {
                      e.stopPropagation(); 
                      openLightbox(idx);
                    }}
                  />
                ))}
              </div>
              <p>Metodoloji çalıştayımız (seminerlerimiz), <strong>09.00 - 18.00</strong> saatleri arasında gerçekleştirilecektir.</p>
            </div>
          </div>

          {/* Gala Yemeği */}
          <div className="program-card">
            <div className="card-header">
              <span className="date">21 Mayıs 2026 Perşembe</span>
              <h3>Gala Yemeği</h3>
            </div>
            <div className="card-body">
              <p><strong>19.00 - 24.00</strong> saatleri arasında gerçekleştirilecektir.</p>
              <div className="address">
                <strong>Mekan:</strong> Royal Palace Artı Davet Salonu <br/>
                Sultanşehir Bulvarı No: 130/B Erzincan Karayolu 3. km Sivas/Merkez
              </div>
            </div>
          </div>

          {/* Sosyal Program - Güncellenen Kısım */}
          <div className="program-card">
            <div className="card-header">
              <span className="date">23 Mayıs 2026 Cumartesi</span>
              <h3>Sosyal Program: GÜRÜN GÖKPINAR GÖLÜ</h3>
            </div>
            <div className="card-body">
              <p>
                Kongremizin 23 Mayıs tarihindeki sosyal programı misafirlerimizin Bayram öncesindeki seyahat planlarını da dikkate alarak 
                <strong> 09.00 - 17.00</strong> saatleri arasında <strong>Gürün Gökpınar Gölü'ne</strong> gerçekleştirilecektir.
              </p>
            </div>
          </div>
        </div>

        {/* POP-UP (LIGHTBOX) MODAL */}
        {isOpen && (
          <div className="lightbox-overlay" onClick={() => setIsOpen(false)}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={() => setIsOpen(false)}>&times;</button>
              
              <button className="nav-btn prev" onClick={() => setPhotoIndex((photoIndex + 3) % 4)}>&#10094;</button>
              
              <div className="image-container">
                <img src={images[photoIndex]} alt="Büyük Görsel" />
                <span className="image-counter">{photoIndex + 1} / 4</span>
              </div>

              <button className="nav-btn next" onClick={() => setPhotoIndex((photoIndex + 1) % 4)}>&#10095;</button>
            </div>
          </div>
        )}

        <div className="update-note">
          <p>* Saatlerle ilgili ortaya çıkabilecek olası değişiklikler ve detaylı program güncellenerek buradan ilan edilecektir.</p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Program;